/* eslint-disable */
export function isNull(val) {
    if (typeof val == "boolean") {
      return false;
    }
    if (typeof val == "number") {
      return false;
    }
    if (val instanceof Array) {
      if (val.length == 0) return true;
    } else if (val instanceof Object) {
      if (JSON.stringify(val) === "{}") return true;
    } else {
      if (
        val == "null" ||
        val == null ||
        val == "undefined" ||
        val == undefined ||
        val == ""
      )
        return true;
      return false;
    }
    return false;
  }
  /**
   * Handles the cars seats data and returns a tree structure.
   *
   * @param {Array} arr - The array of car seat data.
   * @returns {Array} - The tree structure representing the car seat data.
   */
  export const handleCarsSeats = (arr) => {
    const treeData = [];
    const seatTypeArr = [];
    arr.forEach((item) => {
      if (!seatTypeArr.includes(item.seating)) {
        seatTypeArr.push(item.seating);
      }
    });
    seatTypeArr.forEach((ele, index) => {
      treeData.push({
        value: ele,
        children: [],
      });
      let num = 0;
      arr.forEach((child) => {
        if (child.seating === ele) {
          num++;
          treeData[index].children.push(child);
        }
      });
      treeData[index].value = `${ele}座客车${num}辆`;
      treeData[index].terminalNo = `${ele}座客车${num}辆`;
    });
    return treeData;
  };
  
  /**
   * Filters an array of cars based on a given array of checked items.
   *
   * @param {Array} checkedArr - The array of checked items.
   * @param {Array} carsArr - The array of cars to filter.
   * @returns {Array} - The filtered array of cars.
   */
  export const filterShowCars = (checkedArr, carsArr) => {
    const showCars = [];
    checkedArr.forEach((item) => {
      carsArr.forEach((child) => {
        if (item == child.terminalNo) {
          showCars.push(child);
        }
      });
    });
    return showCars;
  };
  